export const ENGLISH_TRANSLATIONS = {
    tuka: {
        frontpage: 'Front page',
        site: {
            name: 'Web publication  ',
        },
        dropdown: {
            select_language: 'Choose language'
        },
        search: {
            search: 'Search',
            clear: 'Clear',
            text_search: 'Text search',
            text_results_header: 'You searched for',
            text_results_clear: 'Go back',
            text_results_count: 'Results:',
            text_results_in_header: 'Otsikossa:',
            text_results_in_content: 'Sisällössä:',
            text_results_in_categories: 'Kategoriossa:',
            text_results_count_in_single_article: 'Hits in the chapter',
            text_input_placeholder: 'Search publication content',
            header: 'Otsikko',
            theme_word: 'Teemasana',
            theme_word_search: 'Select themes',
            theme_words: 'Teemat:',
            theme_word_filtered: 'Navigaatio ja sisältö suodatettu arvoilla:',
            theme_word_filter_clear: 'Tyhjennä Teemat-filtteri'
        },
        navigation: {
            table_of_contents: 'Contents',
            table_of_contents_filtered: 'Sisältö teemalla ',
            table_of_contents_filtered_simple: 'Content with selected theme',
            show_all_content: 'Show full publication',
            page_name: 'Sivun nimi:',
            view: 'Näkymä',
            index_info: 'Aktiivisen kohteen index:',
            open_sidebar : 'Show table of contents',
            close_sidebar : 'Hide table of contents',
            sidebar_open: 'Table of contents open',
            sidebar_closed: 'Table of contents closed',
            accordion_open: 'Subheadings open',
            accordion_closed: 'Subheadings closed',
            skip_to_active_sidebar_item: 'Back to table of contents',
            skip_to_main_content: 'Skip table of contents'
        },
        messages: {
            no_active_themewords: {
                header: 'Näkyvällä sisällöllä ei havaittu valittua teemaa',
                content: 'Voit kokeilla valita uuden web-sisällön sivupalkista, vaihtaa valitun teeman tai suorittaa uuden sisältö-haun.'
            },
            no_web_content: {
                header: 'Etsittyä web-sisältöä ei löytynyt',
                content: '<div><h2>Etsittyä web-sisältöä ei löytynyt</h2><div>Voit kokeilla valita uuden web-sisällön sivupalkista tai suorittaa uuden sisältö-haun.</div></div>'
            },
            no_search_results: 'No search results found. You can try again with another search query.'
        },
        warnings: {
            textSearchValueLength: 'Minimum number of characters in text search:'
        },
        content: {
            table_caption: "Table",
            figure_caption: "Figure",
            info_box: "Information box"
        },
        modal: {
            close: "Sulje"
        }
    }
};